import { render, staticRenderFns } from "./IndustrialMovimatation.vue?vue&type=template&id=79405238&scoped=true"
import script from "./IndustrialMovimatation.vue?vue&type=script&lang=js"
export * from "./IndustrialMovimatation.vue?vue&type=script&lang=js"
import style0 from "./IndustrialMovimatation.vue?vue&type=style&index=0&id=79405238&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79405238",
  null
  
)

export default component.exports